import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { SocialButton } from '@change-corgi/design-system-legacy/components/social';
import { iconCheck } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import type { Props as MainProps } from '../../index';

import { useShareUrl } from './hooks/useShareUrl';

export function ShareUrl({ viewContext }: { viewContext: MainProps['viewContext'] }): JSX.Element {
	const { data, actions } = useShareUrl(viewContext);

	return (
		<SocialButton
			data-testid="copy-link-share-button"
			data-qa="copy-link-share-button"
			channel="copy"
			onClick={actions.handleShare}
			size="small"
			sx={{ width: ['auto', '100%', 'auto'] }}
		>
			<Flex sx={{ alignItems: 'center' }}>
				{data.copied ? (
					<>
						<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_success" />
						<Icon icon={iconCheck} size={20} ml={4} color="typography-positive" />
					</>
				) : (
					<Translate value="corgi.petition.starter_dashboard.recommendations.copy_link.copy_button" />
				)}
			</Flex>
		</SocialButton>
	);
}
